export default __webpack_public_path__ + "static/EuropeanReformation-cfa0d9359015176e8abe768e5e7c3ca4.jpg";